import { Injectable, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { CfgService } from './cfgService';
import { CfgEndpoint } from './cfgEndpoint';
import { StatusResponseDTO, DoorStatus, ToggleRequestDTO } from '../DTO';
import { Subject } from 'rxjs/Subject';

Injectable()
export class StatusService {

  public statuses: EndpointStatus[];
  public get evt_statusUpdated(){ return this.sub_statusUpdated.asObservable(); }
  private sub_statusUpdated = new Subject<EndpointStatus>();

  constructor(@Inject(Http) private http: Http, @Inject(CfgService) private cfg: CfgService) {
    this.getStatus();
  }

  public getStatus = (): Promise<EndpointStatus[]> => {
    return new Promise<EndpointStatus[]>((resolve, reject) => {
      if (this.cfg.cfg) {
        const promises = this.cfg.cfg.map(cfg => this.getStatusSingleEndpoint(cfg));
        Promise.all(promises).then(() => {
          if (this.statuses) {
            for (let i = 0; i < this.statuses.length; i++) {
              const s = this.statuses[i];
              if (this.cfg.cfg.filter(c => c.Url === s.cfg.Url).length === 0) {
                this.statuses.splice(i, 1);
                i--;
              }
            }
          }
          resolve(this.statuses);
        }, (error) => {
          reject();
        });

      }
      else {
        reject();
      }
    });
  }

  public getStatusSingleEndpoint = (cfg: CfgEndpoint): Promise<EndpointStatus> => {
    return new Promise<EndpointStatus>((resolve, reject) => {
      const headers = new Headers();
      headers.append("Authorization", `${cfg.token_type} ${cfg.access_token}`);

      this.http.request(`${cfg.Url}/door/status`, { headers: headers, method: "GET" })
        .toPromise().then(response => {
          const dto = response.json() as StatusResponseDTO
          const status = new EndpointStatus();
          status.cfg = cfg;
          status.statusResponseDTO = dto;
          this.setStatus(status);
          resolve(status);
        }, error => {
          reject(error);
        }).catch((ex) => {
          reject(ex);
        });
    });
  }

  private setStatus = (status: EndpointStatus) => {
    if (!this.statuses) {
      this.statuses = [status];
      this.sub_statusUpdated.next(status);
      return;
    }
    for (let i = 0; i < this.statuses.length; i++) {
      if (this.statuses[i] && this.statuses[i].cfg && this.statuses[i].cfg.Url === status.cfg.Url) {
        this.statuses.splice(i, 1, status);
        this.sub_statusUpdated.next(status);
        return;
      }
    }
    this.statuses.push(status);
    this.sub_statusUpdated.next(status);
  }

  public toggle = (ps: EndpointStatus, s: DoorStatus, action?: string): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      const cfg = ps.cfg;
      const sid = s.sid;

      const headers = new Headers();
      headers.append("Authorization", `${cfg.token_type} ${cfg.access_token}`);
      headers.append("Content-Type", `application/json`);

      const body = new ToggleRequestDTO();
      body.door = s;
      body.action = action;

      this.http.request(`${cfg.Url}/door/toggle`, { headers: headers, method: "POST", body: body })
        .toPromise().then(response => {
          this.autoRefresh(ps.cfg);
          resolve();
        }, error => {
          reject(error);
        }).catch((ex) => {
          reject(ex);
        });
    });
  }

  private autoRefreshTS: { [key: string]: number } = {};

  public autoRefreshAll = (duration?: number, interval?: number) => {
    if (this.cfg && this.cfg.cfg) {
      this.cfg.cfg.forEach(ccfg => {
        this.autoRefresh(ccfg, duration, interval);
      });
    }
  }
  public autoRefresh = (cfg: CfgEndpoint, duration?: number, interval?: number) => {
    if (duration == null || duration === undefined || duration <= 0) {
      duration = 30000;
    }
    if (interval == null || interval === undefined || interval <= 0) {
      interval = 1000;
    }

    const endTS = new Date().getTime() + duration;

    const run = () => {
      const nowTS = new Date().getTime();
      if (nowTS > endTS) return;

      if (this.autoRefreshTS[cfg.Url]) {
        const lastTS = this.autoRefreshTS[cfg.Url];
        if ((nowTS - lastTS) >= interval) {
          this.autoRefreshTS[cfg.Url] = nowTS;
          this.getStatusSingleEndpoint(cfg);
        }
      }
      else {
        this.autoRefreshTS[cfg.Url] = nowTS;
      }


      setTimeout(run, interval / 2);
    }
    run();
  }
}

export class EndpointStatus {
  public cfg: CfgEndpoint;
  public statusResponseDTO: StatusResponseDTO;
}



// WEBPACK FOOTER //
// ./src/app/door/statusService.ts